import { useRouter } from 'next/router'
import { useGqlViewerHasSubmittedExamSurveyQuery } from 'generated/graphql'
import DEFAULT_TEST_ID from '../constants/defaultTestId'

interface UseGetHasSubmittedExamSurveyParams {
  defaultTestId?: string
}

interface UseGetHasSubmittedExamSurveyReturnType {
  isSubmitted: boolean
  loading: boolean
}

type TUseGetHasSubmittedExamSurveyFn = (
  params?: UseGetHasSubmittedExamSurveyParams,
) => UseGetHasSubmittedExamSurveyReturnType

const useGetHasSubmittedExamSurvey: TUseGetHasSubmittedExamSurveyFn = (
  params,
) => {
  const router = useRouter()

  const { loading, data } = useGqlViewerHasSubmittedExamSurveyQuery({
    variables: {
      testId:
        router.query.testId?.toString() ||
        params?.defaultTestId ||
        DEFAULT_TEST_ID,
    },
  })

  const isSubmitted: boolean = data?.viewerHasSubmittedExamSurvey ?? false

  return {
    isSubmitted,
    loading,
  }
}

export default useGetHasSubmittedExamSurvey
export type {
  TUseGetHasSubmittedExamSurveyFn,
  UseGetHasSubmittedExamSurveyParams,
  UseGetHasSubmittedExamSurveyReturnType,
}
